export default {
  fetching: true,
  error: null,
  projects: [],
  filters: {
    search: "",
    page: "1",
    "budget-range": "",
    ward: "",
    status: "",
    sort_by: "",
    order_by: ""
  },
  pagination: {
    total: null,
    start_index: null,
    current_page: null,
    per_page: null,
    total_pages: null
  },
  stats: {
    bidders: 0,
    budget: {
      formatted: "",
      value: 0
    },
    expenditure: {
      formatted: "",
      value: 0
    },
    status_wise: {}
  }
};



// WEBPACK FOOTER //
// ./src/infraMonitor/initialState.js